import { jsx as n } from "react/jsx-runtime";
import { b as l } from "../../../create-theme-BiNW1Sh3.js";
import { c as d } from "../../../index-Cu0xwYjD.js";
import '../../../assets/Badge.css';const f = "_badge_1klxc_4", x = "_success_1klxc_19", j = "_inverted_1klxc_24", w = "_warning_1klxc_29", y = "_error_1klxc_39", p = "_info_1klxc_49", C = "_neutral_1klxc_59", s = {
  badge: f,
  success: x,
  inverted: j,
  warning: w,
  error: y,
  info: p,
  neutral: C
}, N = ({
  children: _,
  customVariant: o,
  inverted: c = !1,
  variant: e = "neutral"
}) => {
  const r = Object.keys(l.color).includes(e), k = Object.keys(l.color.alert).includes(e);
  if (!r && !k)
    throw new Error(
      `Badge variant ${e} is not a valid variant. Please use one of the following: ${[
        ...Object.keys(l.color),
        ...Object.keys(l.color.alert)
      ].join(", ")}`
    );
  const g = r ? (
    // @ts-ignore we're checking the variants above...
    l.color[e][c ? "20" : "70"]
  ) : (
    // @ts-ignore we're checking the variants above...
    l.color.alert[e][c ? "20" : "70"]
  ), b = r ? (
    // @ts-ignore we're checking the variants above...
    l.color[e][c ? "70" : "20"]
  ) : (
    // @ts-ignore we're checking the variants above...
    l.color.alert[e][c ? "70" : "20"]
  );
  return /* @__PURE__ */ n(
    "span",
    {
      style: o ? {
        backgroundColor: c ? o == null ? void 0 : o.color : o == null ? void 0 : o.backgroundColor,
        color: c ? o == null ? void 0 : o.backgroundColor : o == null ? void 0 : o.color
      } : {
        color: g,
        backgroundColor: b
      },
      className: d(s.badge, s[e ?? ""], {
        [s.inverted]: c
      }),
      children: _
    }
  );
};
export {
  N as Badge
};
